<template>
	<Page>
		<b-container>
			<b-row class = "justify-content-md-center">
				<b-col lg="8">
					<div class="about">
						<h1>Некоторые кривые, встречающиеся в математике и её приложениях</h1>
						<hr>
						<p class="author"><b>Работу выполнили:</b> <br>
							Быстров Семён, Группа К3220 <br>
							Панина Елизавета, Группа К3220<br>
							<b>Преподаватель:</b> Исаева Татьяна Тимофеевна</p>
						<hr>
						<h2>Введение</h2>
						<p>Изучение свойств кривых – задача, с которой сталкиваются многие студенты технических специальностей. Мы не стали исключением, по при подготовке работы нам захотелось ещё и:</p>
						<ul>
							<li>увидеть, как меняются графики при различных коэффициентах уравнения кривой,</li>
							<li>изучить, какую роль не только в математике, но и в «жизни» играют эти замечательные кривые,</li>
							<li>собрать и структурировать всю информацию вместе, чтобы показать другим, что это действительно интересная тема.</li>
						</ul>
						<p>Для этого было решено создать данный «справочник по кривым», в котором мы разместили всю собранную в ходе работы информацию.</p>
						<h2>Структура</h2>
						<p>
							Каждая кривая представлена на отдельной странице, которая содержит:
						</p>
						<ul>
							<li>Определение кривой (в виде уравнений различных типов и как геометрическое место точек)</li>
							<li>Координатные оси, на которых можно посмотреть график кривой при выбранных значениях коэффициентов </li>
							<li>«Лирическое отступление» - краткую историческую справку о кривой, интересные факты о ней, а также где можно встретить в природе/инженерных решениях</li>
							<li>Некоторые задачи с решениями для данной кривой</li>
							<li>Ссылки на источники</li>
						</ul>
						<h2 id="contact">Развитие проекта</h2>
						<p>Приветствуется редактирование и добавление информации!<br>
							Связаться с разработчиками можно по почте: <a href="mailto:jobsbystr@gmail.com">jobsbystr@gmail.com</a></p>
						<h2>Инструменты разработки</h2>
						<p>Разработан в среде <a href="https://vuejs.org/">Vue.js</a> с помощью инструмента <a href="https://cli.vuejs.org/">Vue-CLI</a> (с использованием <a href="https://router.vuejs.org/">Vue Router</a>, <a href="https://vuex.vuejs.org/">Vuex</a>)<br>
							Рендеринг формул – <a href="https://www.npmjs.com/package/vue-mathjax">Vue Mathjax</a><br>
							Вёрстка – <a href="https://bootstrap-vue.js.org/">BootstrapVue</a> и <a href="https://nightcatsama.github.io/vue-slider-component/#/">Vue Slider</a></p>
						<p>Работа с графиком реализована самостоятельно через элемент сanvas.</p>
					</div>
				</b-col>
			</b-row>
		</b-container>
	</Page>
</template>

<script>
	import Page from '@/views/templates/Page'
	export default {
		name: 'About',
		data () {
			return {
			}
		},
		components: {
			Page
		}
	}
</script>

<style scoped lang="scss">
	.about {
		margin-top: 40px;
		h1 {
			margin-bottom: 30px;
		}
		.author {
			margin: 20px 0;
			//text-align: right;
		}
	}
</style>
